import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import {
  ActiveInactiveSubCategory,
  createSubCategory,
  deleteSubCategory,
  FindAllActiveCategory,
  getAllActiveSubCategory,
  getAllSubCategory,
  getSubCategoryByID,
  updateSubCategory,
  updateSubCategoryImage,
} from "./services/subCategory.services";

export interface ISubCategoryState {
  loading: boolean;
  formloading: boolean;
  error: string;
  SubCategoryID: number | null;
  SubCategoryList: ISubCategory[];
  CategoriesList: any[];
  SubCategoryDetail: ISubCategoryDetails;
}

export interface ISubCategoryDetails {
  ID?: number | null;
  SubCategory: string;
  SubCategoryURL: string;
  Description: string;
  IsActive: number | boolean;
}
export interface ISubCategory {
  Name: string;
  SubCategoryURL: string;
  CategoryID: number | null;
  Description: string;
  IsActive: number | boolean;
}

const initialState: ISubCategoryState = {
  loading: false,
  formloading: false,
  error: "",
  SubCategoryID: null,
  SubCategoryList: [],
  CategoriesList: [],
  SubCategoryDetail: {
    SubCategory: "",
    SubCategoryURL: "",
    Description: "",
    IsActive: 1,
  },
};

const subCategorySlice = createSlice({
  name: "subCategory",
  initialState,
  reducers: {
    clearSubCategoryDetails: (state) => {
      state.SubCategoryDetail = initialState.SubCategoryDetail;
    },
    setSubCategoryID: (state, action) => {
      state.SubCategoryID = action.payload;
    },
    clearSubCategoryID: (state) => {
      state.SubCategoryID = initialState.SubCategoryID;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(FindAllActiveCategory.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(FindAllActiveCategory.fulfilled, (state, action) => {
      state.loading = false;
      state.CategoriesList = action.payload || [];
      state.error = "";
    });
    builder.addCase(FindAllActiveCategory.rejected, (state, action) => {
      state.loading = false;
      state.CategoriesList = [];
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getAllSubCategory.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllSubCategory.fulfilled,
      (state, action: PayloadAction<ISubCategory[]>) => {
        state.loading = false;
        state.SubCategoryList = action.payload || [];
      }
    );
    builder.addCase(getAllSubCategory.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.SubCategoryList = [];
    });
    builder.addCase(createSubCategory.pending, (state) => {
      state.formloading = true;
      state.error = "";
    });
    builder.addCase(createSubCategory.fulfilled, (state) => {
      state.formloading = false;
    });
    builder.addCase(createSubCategory.rejected, (state, action) => {
      state.formloading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(updateSubCategory.pending, (state) => {
      state.formloading = true;
      state.error = "";
    });
    builder.addCase(updateSubCategory.fulfilled, (state) => {
      state.formloading = false;
    });
    builder.addCase(updateSubCategory.rejected, (state, action) => {
      state.formloading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(deleteSubCategory.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deleteSubCategory.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deleteSubCategory.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getSubCategoryByID.pending, (state) => {
      state.formloading = true;
      state.error = "";
    });
    builder.addCase(getSubCategoryByID.fulfilled, (state, action: any) => {
      state.formloading = false;
      state.SubCategoryDetail = action.payload;
    });
    builder.addCase(getSubCategoryByID.rejected, (state, action) => {
      state.formloading = false;
      state.SubCategoryDetail = initialState.SubCategoryDetail;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getAllActiveSubCategory.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllActiveSubCategory.fulfilled,
      (state, action: PayloadAction<ISubCategory[]>) => {
        state.loading = false;
        state.SubCategoryList = action.payload || [];
      }
    );
    builder.addCase(getAllActiveSubCategory.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.SubCategoryList = [];
    });
    builder.addCase(ActiveInactiveSubCategory.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(ActiveInactiveSubCategory.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(ActiveInactiveSubCategory.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(updateSubCategoryImage.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(updateSubCategoryImage.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(updateSubCategoryImage.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
  },
});

export const { clearSubCategoryDetails, clearSubCategoryID, setSubCategoryID } =
  subCategorySlice.actions;
export default subCategorySlice.reducer;
